import { useAppSelector } from 'app/hooks';
import { useGetUserQuery } from 'app/services/solution';

const useFeatureFlags = () => {
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const userQuery = useGetUserQuery(undefined, { skip: !accessToken });

  return userQuery.data?.FeatureFlags;
};

export default useFeatureFlags;
